import { Autocomplete, Box, TextField } from '@mui/material';
import React from 'react';

import { W_ENTITY_PROPERTIES } from '../../extensions';
import { CommandForm, ICommandFormProps } from './CommandForm';

export interface IToggleWEntityNodeFormProps extends Omit<ICommandFormProps, 'children' | 'fields'> {
  initialOption?: string;
  initialValues?: any;
  onRemove?: () => void;
}

export const ToggleWEntityForm = (props: IToggleWEntityNodeFormProps) => {
  const { ...rest } = props;

  return (
    <CommandForm name="wEntity" {...rest}>
      <Autocomplete
        id="type"
        size="small"
        options={W_ENTITY_PROPERTIES.types}
        autoHighlight
        getOptionLabel={(option: any) => option}
        renderOption={(props, option) => {
          props['data-name'] = 'type';
          return (
            <Box component="li" {...props}>
              {option}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="type"
            label="Type"
            size="small"
            variant="standard"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
          />
        )}
      />
      <TextField name="value" size="small" label="Value" variant="standard" id="outlined-start-Value" />
    </CommandForm>
  );
};
